import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../shared/state/root-reducer';
import RiskAssessmentMain from './risk-assessment-main';
import { Box } from '@mui/material';

function RiskTab() {
    const state = {
        estimate: useSelector(
            (state: RootState) =>
                state.estimatorContext.selectedEstimate
        ),
        // clientDetails: useSelector(
        //     (state: RootState) => state.estimatorContext?.clientDetails
        // ),
    };

    const { estimate } = state;
    // const { estimate, clientDetails } = state;

    return (
        <Box
            style={{
            padding: '1.0em 1.0em 0.5em 1.0em',
            margin: '0 10px'
        }}>
            <RiskAssessmentMain />
        </Box>
    );
}

export default RiskTab; 